import React, { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', message:'' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSent(false);
    setError(false);

    try {
      const res = await fetch("https://sts-lb.net/api/save_message.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      if (data.success) {
        setSent(true);
        setForm({ name:'', email:'', message:'' });
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  }

  return (
    <div className="container" style={{paddingTop:60, paddingBottom:60}}>
      <h2 className="section-title">Get In Touch</h2>

      <div className="contact-wrapper">
        
        <form onSubmit={submit} className='contact-form'>
          <div className="field">
            <input 
              type="text" 
              name="name" 
              required 
              placeholder='' 
              value={form.name}
              onChange={e=>setForm({...form, name:e.target.value})}  
            />
            <label>Your Name</label>
          </div>

          <div className="field">
            <input 
              type="email" 
              name="email" 
              required 
              placeholder='' 
              value={form.email}
              onChange={e=>setForm({...form, email:e.target.value})} 
            />
            <label>Email Address</label>
          </div>

          <div className="field">
            <textarea 
              rows="5" 
              name="message" 
              required 
              placeholder='' 
              value={form.message}
              onChange={e=>setForm({...form, message:e.target.value})} 
            />
            <label>Your Message</label>
          </div>

          <button className='btn btn-primary' type='submit'>
            Send Message
          </button>

          {sent && <div className="contact-success">Message sent — we’ll reply soon.</div>}
          {error && <div className="contact-error">Something went wrong. Please try again.</div>}
        </form>

        <div className="contact-info">
          <h3>Contact Information</h3>
          <p>Have questions or want to request a service?</p>
          <p>We respond fast.</p>

          <div className="info-item">
            📩 smarttechsolutions.lb@gmail.com
          </div>
          <div className="info-item">
            📞 +961 70 429 013
          </div>
          <div className="info-item">
            📍 Beirut, Lebanon
          </div>
        </div>
      </div>
    </div>
  );
}
